import dynamic from 'next/dynamic';
import React from 'react';
import { Loader } from 'ui';

export default function dynamicModal<P = {}>(
  loader: () => Promise<{ default: React.ComponentType<P> }>,
) {
  return dynamic(loader, {
    ssr: false,
    loading: ({ error, isLoading, pastDelay }) =>
      pastDelay ? (
        <Loader loading={!!isLoading} />
      ) : (
        <div
          style={{
            height: 64,
          }}
        />
      ),
  });
}
